import Image from "next/image";
import { MutableRefObject, useContext, useEffect, useRef, useState } from "react";
import AppContext from "../../../../services/app-context-services";
import { ROUTES } from "../../../../services/router-services";
import { isValidPhoneNumber, _, _c } from "../../../../services/text-services";
import Spinner from "../../../shared/spinner/spinner.component";
import logoImage from "../../../../../public/images/logo.png";
import telImage from "../../../../../shared-assets/icons/tel.png";
import { useGoogleAuth } from "../google-auth-hook";
// @ts-ignore
import styles from "./login2.component.module.scss";
import { Input } from "../../../../components/input/input";
import Button from "../../../../components/button/button";
import GoogleButton from "../../../../components/google-button/google-button";
import AppNotifCtx from "../../../../services/notif-context-services";

const LOGIN_DEFAULT_MESSAGE = 'برای تماشا و دانلود نامحدود انیمیشن‌ها شماره موبایل رو وارد کن.';
interface MobileNumberStepProps {
  container: "page" | "modal";
  setMobile: (mobile: string) => void;
  isLoading: boolean;
  errorMessage?: string;
}

function MobileNumberStep2({
  setMobile,
  container,
  isLoading,
  errorMessage
}: MobileNumberStepProps) {
  const [localMobile, setLocalMobile] = useState("");
  const mobileInputEl = useRef<HTMLInputElement>();
  const { url } = useGoogleAuth();
  const { loginMessage, isIntlUser } = useContext(AppContext);
  const logoScale = 1.10;
  const {showNotif} = useContext(AppNotifCtx);


  useEffect(() => {
    mobileInputEl?.current?.focus();
  }, []);

  const trySubmitForm = () => {
    if (isValidPhoneNumber(localMobile)) {
      setMobile(localMobile);
    } else {
      showNotif({
        notifType: "error",
        message: "شماره موبایل معتبر نیست"
      })
    }
  }

  return (
      <div className={`container bg ${styles.wrapper} ${styles[container]}`}>
        <Image src={logoImage} width={200 * logoScale} height={44 * logoScale} alt="message" />
        <p className={_c(styles, "secondary-heading")}>{loginMessage || LOGIN_DEFAULT_MESSAGE}</p>
        <form
          onSubmit={e => {
            e.preventDefault();
            trySubmitForm();
          }}
          className={_c(styles, "login-form")}
        >
          <div className={_c(styles, "input-container")}>
            <Input
              onChange={e => setLocalMobile(e.target.value)}
              onKeyUp={e => {
                if (e.code.includes("Enter")) {
                  trySubmitForm();
                } else {
                  setLocalMobile(mobileInputEl.current.value)
                }
              }}
              label="شماره موبایل"
              type="tel"
              placeholder={_("مثال: 09124567896")}
              autoComplete="off"
              dir="ltr"
              iconLeft={{
                alt: "tel",
                src: telImage,
              }}
              ref={(mobileInputEl as MutableRefObject<HTMLInputElement>)}
            />
          </div>
          {errorMessage && (
            <p className={_c(styles, "error-message")}>{errorMessage}</p>
          )}
          {isLoading ? (
            <div className={_c(styles, "spinner-container")}>
              <Spinner type="tiny" height={150} width={150} />
            </div>
          ) : (
            <>
              <div className={_c(styles, "action-btn-container")}>
                <Button
                  buttonType="submit"
                  type="fill"
                  size="fullWidth"
                  text="دریافت کد"
                  customstyle={{
                    borderRadius: "25px",
                    height: "50px",
                    boxShadow: "0px 4px 8px rgba(74, 87, 131, 0.16)",
                  }}
                />
              </div>
              {!isIntlUser && ( 
                <>
                  <div className={_c(styles, "support-links-container")}>
                    <Button
                      href={ROUTES.contactUs}
                      type="ghost"
                      size="small"
                      color="info"
                      text="پشتیبانی"
                      customstyle={{padding: "0"}}
                      icon={{
                        alt: "tel",
                        path: telImage.src,
                        order: "before",
                      }}
                    />
                    <Button
                      href={ROUTES.terms}
                      type="ghost"
                      size="small"
                      color="info"
                      text="قوانین و شرایط"
                      customstyle={{padding: "0"}}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </form>
      </div>
  );
}

export default MobileNumberStep2;




